import React from 'react';

const YandexMap = () => {
  return (
      <div style={{ position: 'relative', overflow: 'hidden' }}>
        <a
          href="https://yandex.ru/maps/47/nizhny-novgorod/?utm_medium=mapframe&utm_source=maps"
          style={{
            color: '#eee',
            fontSize: '12px',
            position: 'absolute',
            top: '0px',
          }}
        >
          Нижний Новгород
        </a>
        <a
          href="https://yandex.ru/maps/47/nizhny-novgorod/?ll=44.039700%2C56.306603&mode=whatshere&utm_medium=mapframe&utm_source=maps&whatshere%5Bpoint%5D=44.039691%2C56.306598&whatshere%5Bzoom%5D=17&z=16"
          style={{
            color: '#eee',
            fontSize: '12px',
            position: 'absolute',
            top: '14px',
          }}
        >
          Рыбинская улица, 24А на карте Нижнего Новгорода — Яндекс Карты
        </a>
        <iframe
          src="https://yandex.ru/map-widget/v1/?ll=44.039700%2C56.306603&mode=whatshere&whatshere%5Bpoint%5D=44.039691%2C56.306598&whatshere%5Bzoom%5D=17&z=16"
          width="100%"
          height="400"
          frameBorder="0"
          allowFullScreen={true}
          style={{
              position: 'relative',
              borderRadius: '4px',
              overflow: 'hidden',
          }}
        ></iframe>
      </div>
  );
};

export default YandexMap;
